import React from "react";
import { withTranslation } from "react-i18next";
import { Button, Typography } from "@mui/material";
import { Col, Row } from "reactstrap";
import PropTypes from "prop-types";

import InputFieldText from "Components/Common/InputFieldText";
import SelectField from "Components/Common/SelectField";
import ApplicantDetails from "Components/ApplicantDetails";
import { otherUtilityApplicationOptions } from "common/enums";

const NameTransferApplicantDetails = ({ formik, getCustomerDetails, t }) => {
  const {
    values: { utilities, consumerNumber },
    setFieldValue,
  } = formik;

  const searchBtnHandler = async () => {
    try {
      await getCustomerDetails(utilities[0].value, consumerNumber);
    } catch (error) {}
  };

  return (
    <>
      <Row>
        <>
          <Typography className="mb-3" lineHeight="1" variant="h6">
            {t("Customer Details")}:
          </Typography>

          <Col md={4} sm={6}>
            <SelectField
              label={t("Utility") + "*"}
              name="utilities"
              formik={formik}
              options={otherUtilityApplicationOptions}
              value={utilities[0] || ""}
              onChange={(_, option) => {
                setFieldValue("utilities", [option]);
                setFieldValue("consumerNumber", "");
              }}
            />
          </Col>
          <Col md={4} sm={6}>
            <InputFieldText
              label={t("Consumer Number")}
              name="consumerNumber"
              formik={formik}
              placeholder={t("Enter Consumer Number")}
            />
          </Col>
          <Col md={4} sm={6}>
            <Button
              variant="outlined"
              onClick={searchBtnHandler}
              className="me-3 mb-2"
            >
              {t("Search")}
            </Button>
          </Col>
        </>
      </Row>
      <Row>
        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Customer Name") + "*"}
            name="consumerName"
            formik={formik}
            disabled
          />
        </Col>
      </Row>
      <Typography className="mb-3" lineHeight="1" variant="h6">
        {t("Applicant Details")}:
      </Typography>
      <ApplicantDetails formik={formik} isOtherUtilities />
    </>
  );
};
NameTransferApplicantDetails.propTypes = {
  formik: PropTypes.object,
  t: PropTypes.func,
  getCustomerDetails: PropTypes.func,
};
export default withTranslation()(NameTransferApplicantDetails);
